import React from "react";

interface IAiIconProps {
    size?: number;
}

export const AiIcon: React.FC<IAiIconProps> = ({ size = 24 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor"
                  d="M6.342 19.476a.5.5 0 0 1 0-.949l2.152-.717a.5.5 0 0 0 .316-.316l.717-2.152a.5.5 0 0 1 .949 0l.717 2.152a.5.5 0 0 0 .316.316l2.152.717a.5.5 0 0 1 0 .949l-2.152.717a.5.5 0 0 0-.316.316l-.717 2.152a.5.5 0 0 1-.949 0L8.81 20.51a.5.5 0 0 0-.316-.316zM13.513 13.71c-.684-.228-.684-1.195 0-1.423l2.475-.825a.75.75 0 0 0 .474-.474l.825-2.475c.228-.684 1.195-.684 1.423 0l.825 2.475c.075.224.25.4.475.474l2.475.825c.683.228.683 1.195 0 1.423l-2.475.825a.75.75 0 0 0-.475.475l-.825 2.475c-.228.683-1.195.683-1.423 0l-.825-2.475a.75.75 0 0 0-.474-.475zM1.684 7.95c-.912-.303-.912-1.593 0-1.897l2.803-.934a1 1 0 0 0 .632-.632l.934-2.803c.304-.912 1.594-.912 1.898 0l.934 2.803a1 1 0 0 0 .632.632l2.803.934c.912.304.912 1.594 0 1.898l-2.803.934a1 1 0 0 0-.632.632L7.95 12.32c-.304.912-1.594.912-1.898 0L5.12 9.517a1 1 0 0 0-.632-.632z"></path>
        </svg>
    );
};
